import './style.scss';
import React from 'react';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
const CardItems = (props) => {
  return (
    <>
      {props.items?.map((item, index) => {
        const _text = item?.fields?.text;
        const _heading = item?.fields?.heading;
        const _image = item?.fields?.image;
        const shouldRenderTitle = !!_heading?.value;
        const shouldRenderImage = !!_image?.value?.src;
        const shouldRenderDescription = !!_text?.value;

        return (
          <div className="card-item" key={index}>
            <div className="auto">
              {shouldRenderImage && (
                <div className="card-item-image">
                  <Image field={_image} />
                </div>
              )}

              {shouldRenderTitle && (
                <div className="card-item-title">
                  <Text field={_heading} />
                </div>
              )}
              {shouldRenderDescription && (
                <RichText className="card-item-description" field={_text} />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CardItems;
